import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_TIME_PROFILES } from '../get-time-profiles';
import { updateTimeProfilesAPI } from './api';

export function useUpdateTimeProfile() {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const mutation = useMutation(({ id, timeProfile }) => updateTimeProfilesAPI(id, timeProfile), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_TIME_PROFILES, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: {
          type: 'success',
          description: 'timeProfileUpdatedSuccessfully',
        },
      });
    },
    onError: (error) => {
      if (error?.errorMessage?.includes('already exists')) {
        openModal({
          modalType: 'NotificationModal',
          modalProps: { type: 'error', description: 'timeProfileAlreadyExists' },
        });
      } else {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      }
    },
  });

  return {
    ...mutation,
  };
}
